import * as Actions from './constants'

export const loginSuccessAction = (data) => {
  return {
    type: Actions.LOGIN_SUCCESS,
    payload: data,
  }
}

export const restoreUserAction = (user) => {
  return {
    type: Actions.RESTORE_USER,
    payload: user,
  }
}

export const setRegisterInfoAction = (info) => {
  return {
    type: Actions.SET_REGISTER_INFO,
    payload: info,
  }
}

export const changeLanguageAction = (lang) => {
  return {
    type: Actions.CHANGE_LANGAUGE,
    payload: lang,
  }
}
